<template>
    <div class="NoticePage" :class="{'NoticePage-pc': isPc}">
        
        <div class="header">
            <p class="title" v-html="title"></p>
        </div>
        <div class="pre-exam">
            <p class="pre-exam-title" v-html="notice.questionsName"></p>
            <div>
                <p class="pre-exam-text" v-html="notice.text"></p>
            </div>
        </div>
        <div class="btn-box">
            <el-button type="primary" @click="answerSubmitClick">同意并进入考试</el-button>
        </div>
    </div>
</template>

<script>
export default {
    name: 'NoticePage',
    props: {
        notice: {
			type: Object,
			default: () => {
                return {}
            }
        },
        title: {
			type: String,
			default: ''
        },
        isPc: {
			type: Boolean,
			default: false
        },
    },
    data() {
        return{
        }
    },
    created() {
        // console.log(this.notice)
    },
    methods: {
        answerSubmitClick() {
            this.$emit('answerSubmitClick')
        }
    }
}
</script>

<style scoped lang="scss">

.NoticePage-pc{
    box-sizing: border-box;
    margin: auto;
    width: 900px;
}
.NoticePage{
 	min-height: 100vh;
    padding: 60px 40px;
    background-color: #fff;
    .header{
        .title{
            font-size: 22px;
            margin-bottom: 42px;
            text-align: center;
        }
    }
    .pre-exam{
        .pre-exam-title{
            color: #333;
            font-size: 16px;
            padding-bottom: 16px;
        }
        .pre-exam-text{
            background: rgba(241,243,246,.5);
            border-radius: 4px;
            color: #999;
            font-size: 14px;
            padding: 12px;
        }
    }
    .btn-box{
        margin-top: 60px;
        text-align: center;
    }
}
</style>